import { Currency } from '@/constants';

import useChainByCurrency from './useChainByCurrency';

type ChainNamespace = 'eip155' | 'bip122'; // | 'solana' | 'polkadot' ;

function useReownNamespaceByCurrency(currency: Currency.BTC): 'bip122';
function useReownNamespaceByCurrency(currency: Currency.ETH): 'eip155';
function useReownNamespaceByCurrency(currency: Currency): ChainNamespace;
function useReownNamespaceByCurrency(currency: Currency): ChainNamespace {
  const { isEvm, isBtc } = useChainByCurrency(currency);

  const namespace: ChainNamespace = isEvm ? 'eip155' : isBtc ? 'bip122' : 'eip155';

  return namespace;
}

export default useReownNamespaceByCurrency;
